<template>
  <div class="big-box">
    <div class="box-research" @click="submitButton(info.id)">
      <img v-complete:src="info.image" alt="" />

      <div class="box-beijing">
        <p style="cursor: pointer">{{ info.title }}</p>
        <div class="box-tag">
          <el-tag>{{ info.province }}</el-tag>
          <el-tag>{{ info.city }}</el-tag>
          <!-- <el-tag>{{ info.university_type }}</el-tag> -->
          <el-tag
            v-for="(item, index) in info.university_type_text"
            :key="index"
            >{{ item.label }}</el-tag
          >
        </div>
        <div class="icon-box">
          <!-- <el-icon><Document /></el-icon> -->
          <p style="cursor: pointer">
            学校简介：
            <span>
              {{ info.intro }}
              <!-- 北京大学（PekingUniversity），简称“北大”，位于北京市海淀区颐和园路5号，系1111111111111北京大学（PekingUniversity），简称“北大”，位于北京市海淀区颐和园路5号，系1111111111111北京大学（PekingUniversity），简称“北大”，位于北京市海淀区颐和园路5号，系1111111111111北京大学（PekingUniversity），简称“北大”，位于北京市海淀区颐和园路5号，系1111111111111北京大学（PekingUniversity），简称“北大”，位于北京市海淀区颐和园路5号，系1111111111111北京大学（PekingUniversity），简称“北大”，位于北京市海淀区颐和园路5号，系1111111111111 -->
            </span>
          </p>
        </div>
        <!-- <el-button type="primary" @click="detailsThreeButton"
              >查看详情</el-button
            > -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { Calendar } from "@element-plus/icons-vue";
import { User } from "@element-plus/icons-vue";
import { Document } from "@element-plus/icons-vue";
import { reactive } from "vue";

import { useRouter } from "vue-router";

import dayjs from "dayjs";

const router = useRouter();

const mydata = reactive({
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const props = defineProps({
  path: {
    type: String,
    // default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

//按钮点击事件
function submitButton(id) {
  router.push({
    path: props.path,
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.big-box {
  width: 343px;
  // height: 223px;
  margin: 0 auto;
  //  border-top:1px solid #CCCCCC;
  // border: 1px solid rgb(21, 255, 0);
  background-color: #ffffff;
  padding: 16px;
  border-radius: 8px;
}
.box-research {
  width: 100%;
  // height: 163px;
  // margin-top: 40px;
  // border:1px solid rgb(0, 157, 255);
  background-color: #ffffff;
  // display: flex;
  // justify-content: space-between;
  > img {
    width: 100%;
    height: 201px;
    // margin-right: 24px;
    border-radius: 8px;
    display: block;
  }


  .box-beijing {
    margin-top:10px;
    > p {
      font-size: 16px;
      font-weight: 700;
      color: #333333;
    }
    > p:hover {
      color: #009de0;
    }
    .el-tag {
      background: #f0f5ff;
      color: #333333;
      font-size: 12px;
      border: 1px solid #c5cbce;
      margin-top: 18px;
      margin-left: 0px;
      padding: 3px 8px 3px 8px;
      height: 26px;
    }
    .icon-box {
      width: 100%;
      // height: 22px;
      line-height: 22px;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-top: 18px;
      p {
        // border:1px solid rgb(17, 0, 255);
        line-height: 22px;
        display: -webkit-box;
        -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
        text-overflow: ellipsis; //文本溢出 用省略号显示
        -webkit-line-clamp: 3; //几行
        overflow: hidden;
        // margin-left: 8px;
      }
      p:hover {
        color: #009de0;
      }
    }
    :deep(.el-tag.el-tag--primary.el-tag--light) {
      margin-right: 6px;
    }

    // :deep(.el-button.el-button--primary) {
    //   width: 134px;
    //   height: 35px;
    //   padding: 10px;
    //   border-radius: 30px;
    //   position: absolute;
    //   right: 0px;
    //   bottom: 0px;
    //   > span {
    //     color: #ffffff;
    //     font-size: 14px;
    //     font-weight: 400;
    //     line-height: 24px;
    //   }
    // }
  }
}
</style>